import controller from './products-list.controller';
import template from './products-list.view.html';

let ProductsListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<',
    categorySlug: "<",
    categoryId : '<',
    productsList : '<',
    typeview : '<'
  }
};

export default ProductsListComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/products-list/products-list.component.js
 **/